<!-- Simple html that contains the intro text and links in the footer -->
<div class="p-2 h-max max-h-full overflow-y-auto">
  <p>This sample demonstrates a floor planning app built with GoJS and Svelte 5.</p>
  <p>Along with the main diagram, it uses a palette and custom tools for dragging parts, building walls, and resizing wall parts.</p>
  <p>Click the question mark at the top right of the page for more info on how to use the floor planner.</p>
  <p>
    <a href="https://gojs.net">gojs.net</a> -
    <a href="https://gojs.net/latest/samples/">see all GoJS samples</a>
  </p> 
</div>
